import { Linking } from 'react-native'

import { B2, BTN_SM, Button, H4, SH4, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import Announce from '../../../../../assets/svgs/announce.svg'
import Congrats from '../../../../../assets/svgs/congrats.svg'

export const LeadFulFilledBanner = () => {
  function handlePress() {
    Linking.openURL('https://zetapp.in/leads?leadStatus=fullfilled')
  }
  return (
    <Stack className="bg-decorative-coolPurple10 items-center justify-center px-4 py-5">
      <Congrats />
      <H4 className="text-decorative-coolPurple100 mt-1">
        {i18n.t('demoSale.leadFuFilled.h1')}
      </H4>
      <B2 className="mt-1 text-center">
        {i18n.t('demoSale.leadFuFilled.sh1')}
      </B2>
      <XStack className="px-4/2 bg-decorative-bee-20 mt-3 items-center justify-center rounded py-2">
        <Announce />
        <SH4 className="ml-2 leading-4 text-[#291C06]" semibold>
          {i18n.t('demoSale.leadFuFilled.info')}
        </SH4>
      </XStack>
      <Button className="mt-3" onPress={handlePress}>
        <BTN_SM>{i18n.t('demoSale.leadFuFilled.cta')}</BTN_SM>
      </Button>
    </Stack>
  )
}
